import { format } from 'date-fns';
import { ptBR } from 'date-fns/locale';

interface DateRangeDisplayProps {
  dataInicio: Date | string;
  dataFim?: Date | string | null;
  dateFormat?: string;
  separator?: string;
  className?: string;
  uppercase?: boolean;
  prefix?: string;
}

/**
 * Componente para exibir períodos de datas formatados
 *
 * @param dataInicio - Data de início do período
 * @param dataFim - Data de fim do período (opcional)
 * @param dateFormat - Formato da data (padrão: "dd/MM")
 * @param separator - Separador entre as datas (padrão: " A ")
 * @param className - Classes CSS adicionais
 * @param uppercase - Se as datas devem ser em maiúsculas (padrão: false)
 * @param prefix - Texto antes das datas (ex: "PERÍODO PARA CADASTRO: ")
 */
export function DateRangeDisplay({
  dataInicio,
  dataFim,
  dateFormat = 'dd/MM',
  separator = ' A ',
  className = '',
  uppercase = false,
  prefix = ''
}: DateRangeDisplayProps) {
  if (!dataInicio) {
    return null;
  }

  const formatDate = (date: Date | string, formatString: string): string => {
    try {
      const dateObj = typeof date === 'string' ? new Date(date) : date;
      const formatted = format(dateObj, formatString, { locale: ptBR });
      return uppercase ? formatted.toUpperCase() : formatted;
    } catch (error) {
      console.error('Erro ao formatar data:', error);
      return '';
    }
  };

  const inicio = formatDate(dataInicio, dateFormat);
  const fim = dataFim ? formatDate(dataFim, dateFormat) : null;

  const displayText = fim
    ? `${prefix}DE ${inicio}${separator}${fim}`
    : `${prefix}${inicio}`;

  return (
    <span className={className}>
      {displayText}
    </span>
  );
}

export default DateRangeDisplay;
